const isTrue = (value) => value === true || value === 'true'

const mapLegacyToSubscription = (compagnyMeta) => {

    const data = compagnyMeta || {}
    const stripeCustomerId = data.StripeCustomerId || null

    return {
        modules: {
            impactMeten: isTrue(data.ImpactFunctionality),
            personas: isTrue(data.Personas),
            housevisits: isTrue(data.HouseVisits),
            portfolio: isTrue(data.Portfolio),
        },
        billingType: stripeCustomerId ? 'stripe' : 'invoice',
        stripeCustomerId,
        stripeSubscriptionId: null,
        status: null,
        partner: null,
        currentPeriodEnd: null,
        pendingChanges: null,
    }

}

export default mapLegacyToSubscription
